import { ModalParts } from 'BreetComponents';
import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useRateCalculatorContext } from 'BreetHooks';
import { useGetUserWalletsQuery } from 'BreetRedux';
import type { FC } from 'react';

import AssetDetails from './components/asset-details/AssetDetails';
import { Form } from './components/form/Form';
import { useRateCalculatorFormStageContext } from './components/FormStageContext';
import { rateCalculatorStageTitle, type RATECALCULATORTYPE } from './DialogRateCalculator.helpers';

const Child = () => {
	useGetUserWalletsQuery(undefined, alwaysRefetchApiQueryOptions);

	const { selectedAsset } = useRateCalculatorContext();

	const formStage = useRateCalculatorFormStageContext();

	const { isStageActive, stageTitle, navigator } = formStage;

	const stageComponents: Record<RATECALCULATORTYPE, FC> = {
		'rate-calculator': Form,
		'asset-details': AssetDetails,
	};

	const preTitle = isStageActive('asset-details') ? `${selectedAsset?.identifier} ` : '';

	return (
		<ModalParts.Wrapper
			title={`${preTitle}${stageTitle}`}
			rightSheet
			root={rateCalculatorStageTitle['rate-calculator']}
			handleBackLink={navigator.historyBack}
		>
			{Object.entries(stageComponents).map(([stage, Component]) => (
				<ModalParts.Stage
					hide={!isStageActive(stage as RATECALCULATORTYPE)}
					key={stage}
				>
					<Component />
				</ModalParts.Stage>
			))}
		</ModalParts.Wrapper>
	);
};

export default Child;
